import React,{useState} from "react"
import { Flex, Button, message, Typography } from "antd"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { getImportClientDetail, updateExisting } from "store/clients"
import { serialize } from "object-to-formdata"
import styles from "./ImportReport.module.css"
const { Text } = Typography

const DuplicateRecordsSection = ({
  duplicateCount = 0,
  setDuplicateCount,
  duplicateRecords,
  setDuplicateRecords,
  importId,
  t,
  onClose
}) => {
  const dispatch = useDispatch()
  const [existing,setExisting]= useState('')
  const importClientData = useSelector((state) => state.clients.importClientData)
  const handleDuplicateAction = (rowNumber, record, duplicate_action) => {
    setExisting(duplicate_action)
    const guide_client = {
      ...record,
      row: rowNumber,
      duplicate_action,
      error: false
    }
    const formData = serialize({ guide_client }, { indices: true })
    dispatch(updateExisting(formData, importId))
      .then((res) => {
        dispatch(getImportClientDetail(importId))
        message.success(res.message)
        if (onClose) onClose()
      })
      .catch((error) => {
        message.error(error)
      })
  }

  if (duplicateCount === 0) return null
  const isLoadingKeep = !!importClientData.loading && existing === 'keep_existing';
  const isLoadingUpdate = !!importClientData.loading && existing === 'update_existing';

  return (
    <div>
      <p className={styles.infoText}>{t("clients.import_report.duplicates_description")}</p>
      <div className={styles.duplicateRecordItemWrapper}>
        {Object.entries(duplicateRecords).map(([rowNumber, record]) => (
          <div key={rowNumber} className={styles.duplicateRecordItem}>
            <Flex gap={10} className={styles.duplicateRecords}>
              {[
                { title: t("clients.import_report.existing_record"), data: record?.old_row },
                { title: t("clients.import_report.imported_record"), data: record?.row }
              ].map(({ title, data }) => (
                <div key={title} className={styles.recordBox}>
                  <div className={styles.recordBoxHeader}>
                    <h4>{title}</h4>
                  </div>
                  <div className={styles.recordBoxContent}>
                    <p className={styles.highlighted}>
                      {[data?.first_name, data?.last_name].filter(Boolean).join(" ") || t("clients.import_report.not_specified")}
                    </p>
                    <p>
                      <Text type="secondary">{t("common:phone")}:</Text> {data?.phone_number || t("clients.import_report.not_specified")}
                    </p>
                    <p>
                      <Text type="secondary">{t("common:email")}:</Text> {data?.email || t("clients.import_report.not_specified")}
                    </p>
                    <p>
                      <Text type="secondary">{t("common:gender")}:</Text> {data?.gender || t("clients.import_report.not_specified")}
                    </p>
                    <p>
                      <Text type="secondary">{t("common:birthday")}:</Text> {data?.birthday || t("clients.import_report.not_specified")}
                    </p>
                  </div>
                </div>
              ))}
            </Flex>
            <Flex gap={10} className={styles.actionButtons} justify="flex-end">
              <Button
                color="primary"
                variant="outlined"
                loading={isLoadingKeep }
                disabled={isLoadingKeep }
                onClick={() => handleDuplicateAction(rowNumber, record?.old_row, "keep_existing")}
              >
                {t("clients.import_report.keep_existing")}
              </Button>
              <Button
                type="primary"
                loading={isLoadingUpdate}
                disabled={isLoadingUpdate}
                onClick={() => handleDuplicateAction(rowNumber, record?.row, "update_existing")}
              >
                {t("clients.import_report.update_existing")}
              </Button>
            </Flex>
          </div>
        ))}
      </div>
    </div>
  )
}

DuplicateRecordsSection.propTypes = {
  duplicateCount: PropTypes.number,
  duplicateRecords: PropTypes.object,
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  setDuplicateCount: PropTypes.func,
  setDuplicateRecords: PropTypes.func,
  importId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default DuplicateRecordsSection
